import { useState, useEffect } from 'react'

import { isVideoUrl } from '~publish/helpers/isVideoUrl'

interface UseIsVideoUrlParams {
  url: string | null | undefined
}

interface UseIsVideoUrlResult {
  isVideo: boolean
  isLoading: boolean
}

export function useIsVideoUrl({
  url,
}: UseIsVideoUrlParams): UseIsVideoUrlResult {
  const [isVideo, setIsVideo] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function checkVideo(): Promise<void> {
      setIsLoading(true)
      const result = await isVideoUrl(url)
      if (!cancelled) {
        setIsVideo(result)
        setIsLoading(false)
      }
    }

    void checkVideo()
    return (): void => {
      cancelled = true
    }
  }, [url])

  return { isVideo, isLoading }
}
